module.exports = __webpack_public_path__ + "img/4添加原子20220420_100800.b2e15e01.gif";